import getConfig from 'next/config';

import {getApiRequest} from '~/src/utilities/feed/api';
import {Logger} from '~/src/utilities/helpers/log';

const {publicRuntimeConfig: config} = getConfig();

enum SortBy {
    SCORE = 'score',
    RATING = 'rating',
    COMMENTS = 'comments',
    SHARES = 'shares'
}

enum TimeFrame {
    TWELVE_HOURS = '12h',
    ONE_DAY = '1d',
    THREE_DAYS = '3d'
}

interface PopularItemRequest {
    categoryId?: number;
    sortBy?: SortBy;
    tenantId?: number;
    limit?: number;
    timeFrame?: TimeFrame;
}

const getPopularItems = async (request: PopularItemRequest) => {
    const options = {
        tenantId: config.tenantId,
        sortBy: SortBy.SCORE,
        limit: 6,
        timeFrame: TimeFrame.ONE_DAY,
        ...request
    };

    const query = Object.entries(options)
        .filter(([key, value]) => value)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

    try {
        const {collection} = await getApiRequest(`${config.popularity.service.populars}?${query}`);

        return collection;
    } catch (error) {
        Logger.info(`[${error.name}][Rating] Error while getting popular items`, {error});
    }

    return null;
};

export {SortBy, TimeFrame, getPopularItems};
